import type { BuyerProduct } from '@/mock/buyer/products';

const EMOJI: Record<string, string> = {
  '姜': '🌿',
  '蒜': '🧄',
  '洋葱': '🧅',
  '胡萝卜': '🥕',
  '土豆': '🥔',
  '南瓜': '🎃',
  '西兰花': '🥦',
  '苹果': '🍎',
  '梨': '🍐',
  '芒果': '🥭',
  '香蕉': '🍌',
  '柑橘': '🍊',
  '柠檬': '🍋',
  '葡萄': '🍇',
  '草莓': '🍓',
  '蓝莓': '🫐',
  '牛油果': '🥑',
};

export function emojiOf(name = '', category = ''): string {
  for (const k of Object.keys(EMOJI)) if ((name + '-' + category).includes(k)) return EMOJI[k];
  return '📦';
}

export function toDisplayProduct(p: any): BuyerProduct {
  let imageUrls: string[] = [];
  if (p?.imageUrls) {
    try {
      const arr = typeof p.imageUrls === 'string' ? JSON.parse(p.imageUrls) : p.imageUrls;
      if (Array.isArray(arr)) imageUrls = arr.filter((x: unknown) => typeof x === 'string');
    } catch {
      imageUrls = [];
    }
  }
  return {
    id: p?.id,
    name: p?.name ?? '商品',
    category: p?.categoryName ?? p?.category ?? '',
    origin: p?.origin ?? p?.specification ?? '',
    emoji: emojiOf(p?.name, p?.categoryName),
    // 真实挂牌价：后端 BuyerProductVO 已带出（FOB 参考价优先，行情价兜底）
    basePrice: p?.currentFobPrice ?? p?.currentPrice ?? p?.standardPrice ?? p?.price ?? 0,
    containerHint: p?.packagingSpec ?? '',
    description: p?.description ?? '',
    coverImageUrl: p?.coverImageUrl || undefined,
    imageUrls,
    defaultContainerType: p?.defaultContainerType ?? undefined,
    defaultContainerLoadQty: p?.defaultContainerLoadQty ?? undefined,
  };
}

export function toDisplayProducts(list: any[]): BuyerProduct[] {
  return (list ?? []).map(toDisplayProduct);
}
